<template>
  <div class="content">
    <h2 class="h2 white">
      {{ $t("success.title_first_line") }} <br />
      {{ $t("success.title_second_line") }} <br />
      <span class="h2 green" v-if="$t('success.title_third_line')">{{
      $t("success.title_third_line")
      }}</span><br v-if="$t('success.title_third_line')" />
      <span class="h2 green"> {{ $t("success.title_four_line") }}</span>
    </h2>
    <p class="desc">
      {{ $t("success.check") }}
    </p>
    <p 
      v-if="!isResend" 
      class="text"
    >
      {{ $t("success.no_link") }} <span @click="resendEmail()">{{ $t("success.send") }}</span>
    </p>
    <p 
      v-else
      class="text"
    >
      {{ $t("success.resend") }}
    </p>
  </div>
</template>

<script>
  import { register } from "@/services/AuthService";
  export default {
    data() {
      return {
        result: null,
        isResend: false,
        registerBody: {},
        mailFromLand: "",
        sendingMail: ""
      }
    },
    created() {
      if (this.$route.query.mail){
        this.mailFromLand = this.$route.query.mail
      }
    },
    methods:{
      async resendEmail(){
        if (this.$route.query.mail){
          this.sendingMail = this.mailFromLand
        } else{
          this.sendingMail = this.$store.state.registerBody
        }
        this.registerBody = {
          email: this.sendingMail,
          password: Math.random().toString(36).substr(2, 8)
        };        
        this.result = await register(
          JSON.stringify(this.registerBody),
          this.$i18n.locale,
          this.$store.state.base_url
        ).then((res) => {
          this.isResend = true;
          setTimeout(() => this.isResend = false ,30000);
          return res.json();
        })
        .catch((res) => {
          console.log(res.message);
        });
      }
    }
  };
</script>

<style lang="sass" scoped>
  .text
    margin-top: 80px
</style>
